export function formatPhone(phone) {
    var formatted_phone = "(";

    for (var i = 0; i < phone.length; i++) {
        if (i === 3) {
            formatted_phone += ") "
        }

        if (i === 6) {
            formatted_phone += " - "
        }

        formatted_phone +=  phone[i]
    }

    return formatted_phone;
}